import { User } from '../domain/User';

const USER_STORAGE_KEY = 'user';

export function getStoredUser(): User | undefined {
  try {
    const stored = localStorage.getItem(USER_STORAGE_KEY);
    if (!stored || stored === 'undefined' || stored === 'null') {
      return undefined;
    }
    return JSON.parse(stored) as User;
  } catch {
    return undefined;
  }
}

export function persistStoredUser(user: User): void {
  localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
}

export function hasStoredUserSession(): boolean {
  try {
    const stored = localStorage.getItem(USER_STORAGE_KEY);
    return Boolean(stored && stored !== 'undefined' && stored !== 'null');
  } catch {
    return false;
  }
}

export function clearStoredUser(): void {
  localStorage.removeItem(USER_STORAGE_KEY);
}
